import Axios from "axios";
import firebase from "firebase";
import { setSpinner } from "../../../store/Store";
import { verifyLogin } from "../../endpoints";

const signIn = async (email, password) => {
  try {
    setSpinner(true);
    let verify = await Axios.post(verifyLogin, {
      email: email,
      // identifier: Application.applicationId,
      identifier: "com.srvhub.admin.ios",
      // identifier: "com.srvhub.pro",
    });
    let login = await firebase.auth().signInWithEmailAndPassword(email, password);
    await Promise.all([verify, login]);
  } catch (e) {
    console.log(e);
    // flash(e.response.data.error.message, "danger");
    setSpinner(false);
  }
};

export default signIn;
